module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['meta', 'c']),
      expression: "['meta', 'c']"
    }],
    class: {
      copied: _vm.copied
    },
    attrs: {
      "data-id": _vm.page.id,
      "id": "page"
    },
    on: {
      "shortkey": function($event) {
        _vm.copyContent();
      }
    }
  }, [_c('div', {
    staticClass: "toast",
    on: {
      "click": function($event) {
        _vm.copied = '';
      }
    }
  }, [_vm._v("Copied to clipboard!")]), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_c('textarea', {
    directives: [{
      name: "autosize",
      rawName: "v-autosize",
      value: (_vm.input),
      expression: "input"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.input),
      expression: "input"
    }],
    attrs: {
      "id": "input",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.input)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.input = $event.target.value
      }, _vm.updateTextarea]
    }
  }, [_vm._v("      " + _vm._s(_vm.input))]), _vm._v(" "), _c('div', {
    staticClass: "output",
    attrs: {
      "id": "output"
    }
  }, _vm._l((_vm.output), function(line, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('a', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (line),
        expression: "line",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.copySuccess),
        expression: "copySuccess",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.copyError),
        expression: "copyError",
        arg: "error"
      }],
      attrs: {
        "href": "#",
        "title": "Click to copy value"
      }
    }, [_vm._v(_vm._s(line) + "\n        ")])])
  })), _vm._v(" "), _c('prism', {
    staticClass: "sh-input",
    attrs: {
      "language": "javascript"
    }
  }, [_vm._v(_vm._s(_vm.inputTemp))])], 1), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "right"
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.rawOutput),
      expression: "rawOutput",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.copyError),
      expression: "copyError",
      arg: "error"
    }],
    staticClass: "button button-share",
    attrs: {
      "title": "Click to copy everything"
    }
  }, [_vm._v("\n        Copy all\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b710564!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page.vue
// module id = 60
// module chunks = 0